module.exports = __webpack_public_path__ + "static/media/Mehr_Iran.267802a0.svg";